import http, { apiErrorMessage } from "../../http";
import { obtenerTokenWeb, borrarTokenWeb, ACCION_SOLICITUD_DEVOLUCION } from "../../push/firebaseMessaging";

const vRutaNotificaciones = "notificaciones/";
const vRutaAutorizar = "autorizar/";
const LS_TOKEN = "fcmWebToken";

// Total de solicitudes PENDIENTE para la campanita: UNA consulta al cargar el
// dashboard y otra tras resolver; las altas llegan por push (sin polling).
export const getPendientesTotal = () => {
    return (dispatch, getState) => {
        http.get(vRutaAutorizar + "pendientes/total")
            .then(function (response) {
                // Envelope v1: {data:{total}}
                dispatch({ type: "NOTIF_TOTAL_SUCCESS", payload: { total: response.data.data.total } });
            })
            .catch(function (error) {
                dispatch({ type: "NOTIF_ERROR", payload: { error: apiErrorMessage(error) } });
            });
    };
};

// Obtiene el token FCM Web del navegador (pide permiso la primera vez) y lo
// registra en el API de logistica. Solo tiene sentido para usuarios de matriz
// (quien lo llama ya lo verifico). Best-effort: sin permiso o sin soporte, nada.
export const registrarTokenWeb = (pedirPermiso) => {
    return (dispatch, getState) => {
        obtenerTokenWeb(pedirPermiso !== false)
            .then(function (token) {
                if (!token) {
                    dispatch({ type: "NOTIF_TOKEN_NO_DISPONIBLE" });
                    return;
                }
                return http.post(vRutaNotificaciones + "web-token", { token, userAgent: navigator.userAgent })
                    .then(function () {
                        try { localStorage.setItem(LS_TOKEN, token); } catch (e) { /* sin storage */ }
                        dispatch({ type: "NOTIF_TOKEN_REGISTRADO", payload: { token } });
                    });
            })
            .catch(function (error) {
                dispatch({ type: "NOTIF_ERROR", payload: { error: apiErrorMessage(error) } });
            });
    };
};

// Borra el token del navegador en el API (DELETE, mientras el JWT sigue vivo) y
// lo invalida en FCM. Devuelve una promesa que SIEMPRE resuelve: el logout no
// debe quedarse esperando por esto.
export const eliminarTokenWeb = () => {
    return (dispatch, getState) => {
        let token = null;
        try { token = localStorage.getItem(LS_TOKEN); } catch (e) { /* sin storage */ }
        const enApi = token
            ? http.delete(vRutaNotificaciones + "web-token", { data: { token } }).catch(function () { })
            : Promise.resolve();
        const timeout = new Promise(function (resolve) { setTimeout(resolve, 1500); });
        return Promise.race([Promise.all([enApi, borrarTokenWeb()]), timeout]).then(function () {
            try { localStorage.removeItem(LS_TOKEN); } catch (e) { /* sin storage */ }
            dispatch({ type: "NOTIF_TOKEN_ELIMINADO" });
        });
    };
};

// Push recibido en primer plano (onMessage). Solo se atiende la accion del
// aviso de devolucion; el resto se ignora.
export const pushRecibido = (data) => {
    return (dispatch, getState) => {
        if (!data || data.accion !== ACCION_SOLICITUD_DEVOLUCION) {
            return;
        }
        dispatch({
            type: "NOTIF_NUEVA_SOLICITUD",
            payload: {
                solicitud: {
                    id: parseInt(data.solicitud_id, 10) || 0,
                    guia: data.guia || "",
                    tipo: data.tipo || "REVERSION",
                    chofer: data.chofer || "",
                    nombresucursal: data.nombresucursal || "",
                    unidad: data.unidad || "",
                    folioreparto: data.folioreparto || "",
                    motivo: data.motivo || "",
                    fecha: data.fecha || "",
                    titulo: data.titulo || "Solicitud de devolución pendiente",
                    cuerpo: data.cuerpo || "",
                    recibida: Date.now(),
                },
            },
        });
    };
};

// El usuario abrio la campanita / entro a Autorizar: se apagan los "no vistos".
export const marcarVistas = () => {
    return (dispatch, getState) => {
        dispatch({ type: "NOTIF_MARCAR_VISTAS" });
    };
};

export const cerrarAviso = () => {
    return (dispatch, getState) => {
        dispatch({ type: "NOTIF_CERRAR_AVISO" });
    };
};

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({ type: "NOTIF_CLOSE_MESSAGES" });
    };
};
